///<amd-module name="typeahead/core/message/UserExitedMessage" />

import {TypeaheadMessage} from "typeahead/core/message/TypeaheadMessage";

export class UserExitedMessage implements TypeaheadMessage {

    public static getTopic(): string {
        return "typeahead.user_exited";
    }

    public getTopic(): string {
        return UserExitedMessage.getTopic();
    }
}
